import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import "@uppy/core/css/style.min.css";
import "@uppy/dashboard/css/style.min.css";
import { App } from "@/app/App";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
